import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fd11e926"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product flex-row-center"
};
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductScroll',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    productClass: {
      type: String,
      default: ''
    },
    interval: {
      type: Number,
      default: 3000
    }
  },
  setup(__props) {
    const props = __props;
    //const className = ref('')
    //const list=ref<any>([])
    const listRef = ref(null);
    let index = 0;
    let timeoutId = 0;
    const onClickLeft = () => {
      index++;
      if (index >= props.list.length) {
        index = props.list.length - 1;
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(prePic, props.interval);
      } else {
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(nextPic, props.interval);
      }
      //console.log(listRef.value.children[index])
      const el = listRef.value && listRef.value.children[index];
      if (el) listRef.value.scrollTo({
        left: (el.clientWidth + 10) * index,
        behavior: 'smooth'
      });
    };
    const onClickRight = () => {
      index--;
      if (index < 0) {
        index = 0;
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(nextPic, props.interval);
      } else {
        //重置定时器
        clearTimeout(timeoutId);
        timeoutId = setTimeout(prePic, props.interval);
      }
      //console.log(listRef.value.children[index])
      const el = listRef.value && listRef.value.children[index];
      if (el) listRef.value.scrollTo({
        left: (el.clientWidth + 10) * index,
        behavior: 'smooth'
      });
    };
    const nextPic = () => {
      onClickLeft();
      timeoutId = setTimeout(nextPic, props.interval);
    };
    const prePic = () => {
      onClickRight();
      timeoutId = setTimeout(prePic, props.interval);
    };
    onMounted(() => {
      timeoutId = setTimeout(nextPic, props.interval);
    });
    return (_ctx, _cache) => {
      const _component_ProductItem = _resolveComponent("ProductItem");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "arrow left",
        onClick: onClickLeft
      }), _createElementVNode("div", {
        class: "flex-full scroll-x list-container flex-row",
        ref_key: "listRef",
        ref: listRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, i) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: i
        }, [item.disable != false ? (_openBlock(), _createBlock(_component_ProductItem, {
          key: 0,
          item: item,
          "product-class": __props.productClass,
          width: 285
        }, null, 8, ["item", "product-class"])) : _createCommentVNode("", true)], 64);
      }), 128))], 512), _createElementVNode("div", {
        class: "arrow right",
        onClick: onClickRight
      })]);
    };
  }
});